import { LineChart, Percent, BarChart3, Landmark } from "lucide-react";
import { PageHeader } from "@/components/PageHeader";
import { InterestRatesDetail } from "@/components/InterestRatesDetail";
import { MacroData } from "@/components/MacroData";
import { CotPositioning } from "@/components/CotPositioning";
import { ConnectGate } from "@/components/ConnectGate";
import { useLang } from "@/context/LanguageContext";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

export default function Macro() {
  const { t } = useLang();
  const TABS = [
    { v: "macro", label: t("page.macroTabMacro"), icon: BarChart3 },
    { v: "rates", label: t("page.macroTabRates"), icon: Percent },
    { v: "cot", label: t("page.macroTabCot"), icon: Landmark },
  ];
  return (
    <div>
      <PageHeader title={t("page.macroTitle")} subtitle={t("page.macroSub")} icon={LineChart} />
      <ConnectGate>
        <Tabs defaultValue="macro">
          <TabsList className="mb-4 flex-wrap bg-[#11141A]" data-testid="macro-tabs">
            {TABS.map((tab) => (
              <TabsTrigger key={tab.v} value={tab.v} data-testid={`macro-tab-${tab.v}`} className="gap-1.5 data-[state=active]:bg-blue-600 data-[state=active]:text-white">
                <tab.icon className="h-3.5 w-3.5" /> {tab.label}
              </TabsTrigger>
            ))}
          </TabsList>
          <TabsContent value="macro">
            <div className="rounded-lg border border-[#222733] bg-[#11141A] p-4 sm:p-6"><MacroData /></div>
          </TabsContent>
          <TabsContent value="rates">
            <div className="rounded-lg border border-[#222733] bg-[#11141A] p-4 sm:p-6"><InterestRatesDetail /></div>
          </TabsContent>
          <TabsContent value="cot">
            <div className="rounded-lg border border-[#222733] bg-[#11141A] p-4 sm:p-6"><CotPositioning /></div>
          </TabsContent>
        </Tabs>
      </ConnectGate>
    </div>
  );
}
